const moduleList = [
    {
        "title" : "Auditory",  
        "folderName" : "auditory",     
        "isRandomise" : false,
        "items": [
            {
                "title": "1. Auditory Analysis",                
                "folderName" : "audanalysis",
                "isRandomise" : false,
                "items" : [
                    {
                        "title" : "1.1 Vowels",
                        "folderName" : "vowels",
                        "isRandomise" : true,
                        "subTitle" : "hunt the vowels",
                        "testCode" : 1,
                        "items" : [],
                        "instruction" : "ಶಬ್ದಗಳಲ್ಲಿ ನೀವು ಕೇಳುವ ಸ್ವರಗಳನ್ನು ಹುಡುಕಿ ?",
                        "example" : "ಉದಾಹರಣೆ : ಕೊ  = ಒ"
                    }, 
                    {
                        "title" : "1.2 Number of sounds",
                        "folderName" : "numbersounds",
                        "isRandomise" : true,
                        "subTitle" : "count me if you can",
                        "testCode" : 1,
                        "items" : [],
                        "instruction" : "ಈ ಪದವನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅದರಲ್ಲಿ ಎಷ್ಟು ಶಬ್ದಗಳಿವೆ ಎಂದು ಹೇಳಬಲ್ಲಿರಾ?",
                        "example" : "ಉದಾಹರಣೆ : ಅಗಸ = 3"
                    }, 
                    {
                        "title" : "1.3 Syllable number",
                        "folderName" : "syllablenum",
                        "isRandomise" : true,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title": "1.3.1 Initial",
                                "folderName" : "initial",
                                "isRandomise" : true,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ನೀವು ಕೇಳುವ ಪದದಲ್ಲಿನ ಮೊದಲ ಅಕ್ಷರವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ",
                                "example" : "ಉದಾಹರಣೆ : ಅಪ್ಪ = ಅ"
                            },
                            {
                                "title": "1.3.2 Medial",
                                "folderName" : "medial",
                                "isRandomise" : true,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ನೀವು ಕೇಳುವ ಪದದಲ್ಲಿನ ಮಧ್ಯದ ಅಕ್ಷರವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ",
                                "example" : "ಉದಾಹರಣೆ : ಕಮಲ = ಮ"                                
                            },
                            {
                                "title": "1.3.3 Final",
                                "folderName" : "final",
                                "isRandomise" : true,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ನೀವು ಕೇಳುವ ಪದದಲ್ಲಿನ ಕೊನೆಯ ಅಕ್ಷರವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ",
                                "example" : "ಉದಾಹರಣೆ : ಆಹಾರ = ರ"
                            },
                        ],
                        "instruction" : "",
                        "example": ""
                    }, 
                    {
                        "title" : "1.4 Syllable recognition",
                        "folderName" : "syllableRec",
                        "isRandomise" : true,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title": "Familiar",                                 
                                "folderName" : "familiar",
                                "isRandomise" : true,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ನೀವು ಕೇಳುವ ಪದದಲ್ಲಿ ಯಾವ ಯಾವ  ಅಕ್ಷರಗಳಿವೆ ಎಂದು ಹೇಳಿ?",
                                "example" : "ಉದಾಹರಣೆ : ಆರು = ಆ-ರು"
                            },
                            {
                                "title": "Unfamiliar",    
                                "folderName" : "unfamiliar",                             
                                "isRandomise" : true,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ನೀವು ಕೇಳುವ ಪದದಲ್ಲಿ ಯಾವ ಯಾವ  ಅಕ್ಷರಗಳಿವೆ ಎಂದು ಹೇಳಿ?",
                                "example" : "ಉದಾಹರಣೆ : ಬರಹ = /ಬ/ /ರ/ /ಹ/"
                            }
                        ],
                        "instruction" : "ನೀವು ಕೇಳುವ ಪದದಲ್ಲಿ ಯಾವ ಯಾವ  ಅಕ್ಷರಗಳಿವೆ ಎಂದು ಹೇಳಿ?",
                        "example":""
                    },
                ],
                "instruction" : "",
                "example":""
            },
            {
                "title": "2. Auditory Attention",                
                "folderName" : "audatten",    
                "isRandomise" : false,
                "items" : [
                    {
                        "title" : "2.1 Single step commands",
                        "folderName" : "singlestep",   
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [],
                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅದರಂತೆ ಅನುಸರಿಸಿ.",
                        "example" : "ಉದಾಹರಣೆ : ಚಪ್ಪಾಳೆ ತಟ್ಟಿರಿ"
                    },
                    {
                        "title" : "2.2 2-step commands",
                        "folderName" : "TwoStep",  
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [],
                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅದರಂತೆ ಅನುಸರಿಸಿ.",
                        "example" : "ಉದಾಹರಣೆ : ಬಾಗಿಲಿಗೆ ನಡೆದು ತಟ್ಟಿ"
                    },
                    {
                        "title" : "2.3 3-step commands",
                        "folderName" : "ThreeStep", 
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [],
                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅದರಂತೆ ಅನುಸರಿಸಿ.",
                        "example" : "ಉದಾಹರಣೆ : ಪೇಪರ್ ತೆಗೆದುಕೊಂಡು ಪೆನ್ಸಿಲ್ ತೆಗೆದುಕೊಂಡು ನನಗೆ ಕೊಡು"
                    },
                    {
                        "title" : "2.4 story comprehension",
                        "folderName" : "FourStep",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 4.2,
                        "items" : [],
                        "instruction" : "ನಾನು ಹೇಳುವ ಕಥೆಯನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ನಂತರ ಅದಕ್ಕೆ ಸಂಬಂದಿಸಿದ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಿ",
                        "example" : ""

                    },
                ],
                "instruction" : "",
                "example" :""
            },
            {
                "title": "3. Auditory Association",               
                "folderName" : "AudAssoc",    
                "isRandomise" : false,
                "items" : [
                    {
                        "title" : "3.1 vowels",
                        "folderName" : "Vowels",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 3,
                        "items" : [
                            {
                                "title" : "Easy",
                                "folderName" : "easy",
                                "isRandomise" : false,
                                "testCode" : 3,
                                "items" : [],
                                "instruction" : "ಕೇಳಿದ ಅಕ್ಷರವನ್ನು ಗುರುತಿಸಿ", 
                                "example" : "ಉದಾಹರಣೆ: ಆ ಶಬ್ದವನ್ನು  ಕೇಳಿ = ಈ ಉ ಆ|ಉತ್ತರ: ಆ ಅಕ್ಷರವನ್ನು ತೊರಿಸಬೇಕು"
                            },
                            {
                                "title" : "Difficult",
                                "folderName" : "difficult",
                                "isRandomise" : false,
                                "testCode" : 3,
                                "items" : [],
                                "instruction" : "ಕೇಳಿದ ಅಕ್ಷರವನ್ನು ಗುರುತಿಸಿ", 
                                "example" : "ಉದಾಹರಣೆ: ಆ ಶಬ್ದವನ್ನು  ಕೇಳಿ = ಈ ಉ ಆ|ಉತ್ತರ: ಆ ಅಕ್ಷರವನ್ನು ತೊರಿಸಬೇಕು"
                            },
                            {
                                "title" : "Hard",
                                "folderName" : "Hard",
                                "isRandomise" : false,
                                "testCode" : 3,
                                "items" : [],
                                "instruction" : "ಕೇಳಿದ ಅಕ್ಷರವನ್ನು ಗುರುತಿಸಿ", 
                                "example" : "ಉದಾಹರಣೆ: ಆ ಶಬ್ದವನ್ನು  ಕೇಳಿ = ಈ ಉ ಆ|ಉತ್ತರ: ಆ ಅಕ್ಷರವನ್ನು ತೊರಿಸಬೇಕು"
                            }
                        ],
                        "instruction" : "",
                        "example" : ""
                    }, 
                    {
                        "title" : "3.2 consonants",
                        "folderName" : "Consonants",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 3,
                        "items" : [
                            {
                                "title" : "Easy",
                                "folderName" : "easy",
                                "isRandomise" : false,
                                "testCode" : 3,
                                "items" : [],
                                "instruction" : "ಕೇಳಿದ ಅಕ್ಷರವನ್ನು ಗುರುತಿಸಿ", 
                                "example" : "ಉದಾಹರಣೆ: ಕ ಶಬ್ದವನ್ನು ಕೇಳಿ = ಕ ,ತ,  ಪ|ಉತ್ತರ: ಕ ಅಕ್ಷರವನ್ನು ತೊರಿಸಬೇಕು"
                            },
                            {
                                "title" : "Difficult",
                                "folderName" : "difficult",
                                "isRandomise" : false,
                                "testCode" : 3,
                                "items" : [],
                                "instruction" : "ಕೇಳಿದ ಅಕ್ಷರವನ್ನು ಗುರುತಿಸಿ", 
                                "example" : "ಉದಾಹರಣೆ: ಕ ಶಬ್ದವನ್ನು ಕೇಳಿ = ಕ ,ತ,  ಪ|ಉತ್ತರ: ಕ ಅಕ್ಷರವನ್ನು ತೊರಿಸಬೇಕು"
                            },
                            {
                                "title" : "Hard",
                                "folderName" : "Hard",
                                "isRandomise" : false,
                                "testCode" : 3,
                                "items" : [],
                                "instruction" : "ಕೇಳಿದ ಅಕ್ಷರವನ್ನು ಗುರುತಿಸಿ", 
                                "example" : "ಉದಾಹರಣೆ: ಕ ಶಬ್ದವನ್ನು ಕೇಳಿ = ಕ ,ತ,  ಪ|ಉತ್ತರ: ಕ ಅಕ್ಷರವನ್ನು ತೊರಿಸಬೇಕು"
                            }
                        ],
                        "instruction" : "",
                        "example" : ""
                    },
                    {
                        "title" : "3.3 syllables",
                        "folderName" : "Syllables",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 3,
                        "items" : [],
                        "instruction" : "ಕೇಳಿದ ಅಕ್ಷರವನ್ನು ಗುರುತಿಸಿ",
                        "example" : "ಉದಾಹರಣೆ: ರೀ ಶಬ್ದವನ್ನು ಕೇಳಿ = ರೀ ,ಕು , ಮ|ಉತ್ತರ: ರೀ ಅಕ್ಷರವನ್ನು ತೊರಿಸಬೇಕು"
                    },
                    {
                        "title" : "3.4 words",
                        "folderName" : "Words",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 3,
                        "items" : [],
                        "instruction" : "ಕೇಳಿದ ಪದವನ್ನು ಗುರುತಿಸಿ",
                        "example" : "ಉದಾಹರಣೆ:ಊಟ ಪದವನ್ನು ಕೇಳಿ = ಊಟ , ಮನೆ , ಪಾಠ|ಉತ್ತರ: ಊಟ ಪದವನ್ನ ತೊರಿಸಬೇಕು"
                    },
                    {
                        "title" : "3.5 sentences",
                        "folderName" : "Sentences",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 3.1,
                        "items" : [
                            {
                                "title" : "Easy",
                                "folderName" : "easy",
                                "isRandomise" : false,
                                "testCode" : 3.1,
                                "items" : [],
                                "instruction" : "ಕೇಳಿದ ವಾಕ್ಯವನ್ನು ಗುರುತಿಸಿ", 
                                "example" : ""
                            },
                            {
                                "title" : "Difficult",
                                "folderName" : "difficult",
                                "isRandomise" : false,
                                "testCode" : 3.1,
                                "items" : [],
                                "instruction" : "ಕೇಳಿದ ವಾಕ್ಯವನ್ನು ಗುರುತಿಸಿ", 
                                "example" : ""
                            },
                            {
                                "title" : "Hard",
                                "folderName" : "Hard",
                                "isRandomise" : false,
                                "testCode" : 3.1,
                                "items" : [],
                                "instruction" : "ಕೇಳಿದ ವಾಕ್ಯವನ್ನು ಗುರುತಿಸಿ", 
                                "example" : ""
                            }
                        ],
                        "instruction" : "ಕೇಳಿದ ವಾಕ್ಯವನ್ನು ಗುರುತಿಸಿ",
                        "example" : ""
                    },
                ],
                "instruction" : "",
                "example" : ""
            },
            {
                "title": "4. Auditory Closure",                
                "folderName" : "AudClosure",    
                "isRandomise" : false,
                "items" : [
                    {
                        "title" : "4.1 Missing words",
                        "folderName" : "MissingWords",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title": "4.1.1 Initial",
                                "folderName" : "Initial",
                                "isRandomise" : true,
                                "subtitle": "",
                                "testCode" : 1,
                                "items": [
                                    {
                                        "title" : "Easy",
                                        "folderName" : "easy",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : .... ತಗಡಿನ ತುತ್ತೂರಿ|ಉತ್ತರ: ಬಣ್ಣದ"
                                    },
                                    {
                                        "title" : "Difficult",
                                        "folderName" : "difficult",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : .... ತಗಡಿನ ತುತ್ತೂರಿ|ಉತ್ತರ: ಬಣ್ಣದ"
                                    },
                                    {
                                        "title" : "Hard",
                                        "folderName" : "Hard",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : .... ತಗಡಿನ ತುತ್ತೂರಿ|ಉತ್ತರ: ಬಣ್ಣದ"
                                    }
                                ],
                                "instruction" : "", 
                                "example" : ""
                            },
                            {
                                "title": "4.1.2 medial",
                                "folderName" :"Medial",       
                                "isRandomise" : false,                         
                                "subtitle": "",
                                "testCode" : 1,
                                "items": [
                                    {
                                        "title" : "Easy",
                                        "folderName" : "easy",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : ಒಂದು ..... ಬಾಳೆಲೆ ಹರಡು|ಉತ್ತರ: ಎರಡು"
                                    },
                                    {
                                        "title" : "Difficult",
                                        "folderName" : "difficult",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : ಒಂದು ..... ಬಾಳೆಲೆ ಹರಡು|ಉತ್ತರ: ಎರಡು"
                                    },
                                    {
                                        "title" : "Hard",
                                        "folderName" : "Hard",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : ಒಂದು ..... ಬಾಳೆಲೆ ಹರಡು|ಉತ್ತರ: ಎರಡು"
                                    }
                                ],
                                "instruction" : "",
                                "example" : ""
                            },
                            {
                                "title": "4.1.3 Final",
                                "folderName" :"Final",
                                "isRandomise" : false,
                                "subtitle": "",
                                "testCode" : 1,
                                "items": [
                                    {
                                        "title" : "Easy",
                                        "folderName" : "easy",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : ನಾಯಿ ಮರಿ ನಾಯಿ ಮರಿ ತಿಂಡಿ.....|ಉತ್ತರ: ಬೇಕೇ"
                                    },
                                    {
                                        "title" : "Difficult",
                                        "folderName" : "difficult",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : ನಾಯಿ ಮರಿ ನಾಯಿ ಮರಿ ತಿಂಡಿ.....|ಉತ್ತರ: ಬೇಕೇ"
                                    },
                                    {
                                        "title" : "Hard",
                                        "folderName" : "Hard",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : ನಾಯಿ ಮರಿ ನಾಯಿ ಮರಿ ತಿಂಡಿ.....|ಉತ್ತರ: ಬೇಕೇ"
                                    }
                                ],
                                "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                "example" : "ಉದಾಹರಣೆ : ನಾಯಿ ಮರಿ ನಾಯಿ ಮರಿ ತಿಂಡಿ.....|ಉತ್ತರ: ಬೇಕೇ"
                            },
                        ],
                        "instruction" : "",
                        "example" : ""
                    },
                    {
                        "title": "4.2 Missing Syllable",
                        "folderName" : "MissingSyllable",
                        "isRandomise" : false,
                        "subTitle": "",
                        "testCode" : 1,
                        "items": [
                            {
                                "title": "4.2.1 Initial",
                                "folderName" : "Initial",
                                "isRandomise" : false,
                                "subTitle": "",
                                "testCode" : 1,
                                "items": [
                                    {
                                        "title" : "Easy",
                                        "folderName" : "easy",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : ಆಕಾಶದಲ್ಲಿ  _ಮಾನ ಹಾರುತ್ತದೆ = ವಿ"
                                    },
                                    {
                                        "title" : "Difficult",
                                        "folderName" : "difficult",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : ಆಕಾಶದಲ್ಲಿ  _ಮಾನ ಹಾರುತ್ತದೆ = ವಿ"
                                    },
                                    {
                                        "title" : "Hard",
                                        "folderName" : "Hard",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                        "example" : "ಉದಾಹರಣೆ : ಆಕಾಶದಲ್ಲಿ  _ಮಾನ ಹಾರುತ್ತದೆ = ವಿ"
                                    }
                                ],
                                "instruction" : "",
                                "example" : ""
                            },
                            {
                                "title": "4.2.2 Medial",
                                "folderName" : "Medial",
                                "isRandomise" : false,
                                "subTitle": "",
                                "testCode" : 1,
                                "items": [{
                                    "title" : "Easy",
                                    "folderName" : "easy",
                                    "isRandomise" : true,
                                    "testCode" : 1,
                                    "items" : [],
                                    "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                    "example" : "ಉದಾಹರಣೆ : ದೀಪಾವಳಿ ಹಬ್ಬದಲ್ಲಿ ಮಕ್ಕಳು ಪ_ಕಿ ಹಚ್ಚಿದರು  = ಟಾ"
                                },
                                {
                                    "title" : "Difficult",
                                    "folderName" : "difficult",
                                    "isRandomise" : true,
                                    "testCode" : 1,
                                    "items" : [],
                                    "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                    "example" : "ಉದಾಹರಣೆ : ದೀಪಾವಳಿ ಹಬ್ಬದಲ್ಲಿ ಮಕ್ಕಳು ಪ_ಕಿ ಹಚ್ಚಿದರು  = ಟಾ"
                                },
                                {
                                    "title" : "Hard",
                                    "folderName" : "Hard",
                                    "isRandomise" : true,
                                    "testCode" : 1,
                                    "items" : [],
                                    "instruction" : "ಬಿಟ್ಟ ಪದವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                    "example" : "ಉದಾಹರಣೆ : ದೀಪಾವಳಿ ಹಬ್ಬದಲ್ಲಿ ಮಕ್ಕಳು ಪ_ಕಿ ಹಚ್ಚಿದರು  = ಟಾ"
                                }],
                                "instruction" : "ಬಿಟ್ಟ ಅಕ್ಷರವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                "example" : "ಉದಾಹರಣೆ : ದೀಪಾವಳಿ ಹಬ್ಬದಲ್ಲಿ ಮಕ್ಕಳು ಪ_ಕಿ ಹಚ್ಚಿದರು  = ಟಾ"
                            },
                            {
                                "title": "4.2.3 Final",
                                "folderName" : "Final",
                                "isRandomise" : false,
                                "subTitle": "",
                                "testCode" : 1,
                                "items": [{
                                    "title" : "Easy",
                                    "folderName" : "easy",
                                    "isRandomise" : true,
                                    "testCode" : 1,
                                    "items" : [],
                                    "instruction" : "ಬಿಟ್ಟ ಅಕ್ಷರವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                    "example" : "ಉದಾಹರಣೆ : ಪುಸ್ತಕವನ್ನು ಹೆಚ್ಚು ಓದುವುದರಿಂದ ಜ್ಞಾ_ ಹೆಚ್ಚಾಗುತ್ತದೆ. = ನ"
                                },
                                {
                                    "title" : "Difficult",
                                    "folderName" : "difficult",
                                    "isRandomise" : true,
                                    "testCode" : 1,
                                    "items" : [],
                                    "instruction" : "ಬಿಟ್ಟ ಅಕ್ಷರವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                    "example" : "ಉದಾಹರಣೆ : ಪುಸ್ತಕವನ್ನು ಹೆಚ್ಚು ಓದುವುದರಿಂದ ಜ್ಞಾ_ ಹೆಚ್ಚಾಗುತ್ತದೆ. = ನ"
                                },
                                {
                                    "title" : "Hard",
                                    "folderName" : "Hard",
                                    "isRandomise" : true,
                                    "testCode" : 1,
                                    "items" : [],
                                    "instruction" : "ಬಿಟ್ಟ ಅಕ್ಷರವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                    "example" : "ಉದಾಹರಣೆ : ಪುಸ್ತಕವನ್ನು ಹೆಚ್ಚು ಓದುವುದರಿಂದ ಜ್ಞಾ_ ಹೆಚ್ಚಾಗುತ್ತದೆ. = ನ"
                                }],
                                "instruction" : "ಬಿಟ್ಟ ಅಕ್ಷರವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ", 
                                "example" : "ಉದಾಹರಣೆ : ಪುಸ್ತಕವನ್ನು ಹೆಚ್ಚು ಓದುವುದರಿಂದ ಜ್ಞಾ_ ಹೆಚ್ಚಾಗುತ್ತದೆ. = ನ"
                            },
                        ],
                        "instruction" : "ಬಿಟ್ಟ ಅಕ್ಷರವನ್ನು ಪತ್ತೆ ಹಚ್ಚಿ",
                        "example" : ""
                    }
                ], 
                "instruction" : "",
                "example" : ""
            },
            {
                "title": "5. Auditory Discrimination",                
                "folderName" : "AudDisc",    
                "items" : [
                    {
                        "title" : "5.1 Vowels",
                        "folderName" : "Vowels",    
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title" : "Easy",
                                "folderName" : "easy",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಈ ಶಬ್ದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ", 
                                "example" : "ಉದಾಹರಣೆ : ಓ - ಉ = ಬೇರೆ"
                            },
                            {
                                "title" : "Difficult",
                                "folderName" : "difficult",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಈ ಶಬ್ದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ", 
                                "example" : "ಉದಾಹರಣೆ : ಓ - ಉ = ಬೇರೆ"
                            },
                            {
                                "title" : "Hard",
                                "folderName" : "Hard",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಈ ಶಬ್ದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ", 
                                "example" : "ಉದಾಹರಣೆ : ಓ - ಉ = ಬೇರೆ"
                            }
                        ],
                        "instruction" : "ಈ ಶಬ್ದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ", 
                        "example" : "ಉದಾಹರಣೆ : ಓ - ಉ = ಬೇರೆ"
                    },
                    {
                        "title" : "5.2 Consonants",
                        "folderName" : "Consonants",  
                        "isRandomise" : false,  
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title": "5.2.1 Easy",
                                "folderName" : "Easy",    
                                "isRandomise" : false,
                                "subTitle":"",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ಈ ಶಬ್ದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ಗ - ಮ = ಬೇರೆ"
                            },
                            {
                                "title": "5.2.2 Difficult",
                                "folderName" : "Difficult",    
                                "isRandomise" : false,
                                "subTitle":"",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ಈ ಶಬ್ದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ಕ - ಖ  =ಬೇರೆ"
                            },
                        ],
                        "instruction" : "",
                        "example" : ""
                    },
                    {
                        "title" : "5.3 Clusters",
                        "folderName" : "Clusters",  
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title" : "Easy",
                                "folderName" : "easy",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಈ ಶಬ್ದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ಸ್ತ್ರೀ - ಸ್ತ್ರೀ = ಒಂದೇ"
                            },
                            {
                                "title" : "Difficult",
                                "folderName" : "difficult",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಈ ಶಬ್ದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ಸ್ತ್ರೀ - ಸ್ತ್ರೀ = ಒಂದೇ"
                            },
                            {
                                "title" : "Hard",
                                "folderName" : "Hard",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಈ ಶಬ್ದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ಸ್ತ್ರೀ - ಸ್ತ್ರೀ = ಒಂದೇ"
                            }
                        ],
                        "instruction" : "ಈ ಶಬ್ದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ",
                        "example" : "ಉದಾಹರಣೆ : ಸ್ತ್ರೀ - ಸ್ತ್ರೀ = ಒಂದೇ"
                    },
                    {
                        "title" : "5.4 Phrases",
                        "folderName" : "Phrases",  
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title" : "Easy",
                                "folderName" : "easy",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಈ ಪದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ",
                                "example": "ಉದಾಹರಣೆ : ಬಹಳ ಒಳ್ಳೆಯ - ಬಹಳ ಒಳ್ಳೆಯ = ಒಂದೇ"
                            },
                            {
                                "title" : "Difficult",
                                "folderName" : "difficult",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಈ ಪದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ",
                                "example": "ಉದಾಹರಣೆ : ಬಹಳ ಒಳ್ಳೆಯ - ಬಹಳ ಒಳ್ಳೆಯ = ಒಂದೇ"
                            },
                            {
                                "title" : "Hard",
                                "folderName" : "Hard",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಈ ಪದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ",
                                "example": "ಉದಾಹರಣೆ : ಬಹಳ ಒಳ್ಳೆಯ - ಬಹಳ ಒಳ್ಳೆಯ = ಒಂದೇ"
                            }
                        ],
                        "instruction" : "ಈ ಪದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅವುಗಳು ಒಂದೇ ಅಥವಾ ಬೇರೆಯೇ ಎಂದು ಹೇಳಿ",
                        "example": "ಉದಾಹರಣೆ : ಬಹಳ ಒಳ್ಳೆಯ - ಬಹಳ ಒಳ್ಳೆಯ = ಒಂದೇ"
                    },
                ],
                "instruction" : "",
                "example" : ""
            },
            {
                "title": "6. Temporal Patterning",         
                "folderName" : "TempPattern",    
                "isRandomise" : false,
                "items" : [
                    {
                        "title" : "6.1 Auditory Pattern",
                        "folderName" : "AudPattern",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title" : "2 Pattern",
                                "folderName" : "twopat",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಶಬ್ದಗಳನ್ನು  ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "", 
                            },
                            {
                                "title" : "3 Pattern",
                                "folderName" : "threepat",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಶಬ್ದಗಳನ್ನು  ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "", 
                            },
                            {
                                "title" : "4 Pattern",
                                "folderName" : "fourpat",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಶಬ್ದಗಳನ್ನು  ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "", 
                            }
                        ],
                        "instruction" : "ಶಬ್ದಗಳನ್ನು  ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                        "example" : "",                        
                    },
                    {
                        "title" : "6.2 Humming",
                        "folderName" : "Humming",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title" : "2 Pattern",
                                "folderName" : "twopat",
                                "isRandomise" : false,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಗುನುಗುವುದನ್ನು ಕೇಳಿ ಅದರಂತೆ ನೀವು ಅನುಸರಿಸಿ",
                                "example" : "", 
                            },
                            {
                                "title" : "3 Pattern",
                                "folderName" : "threepat",
                                "isRandomise" : false,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಗುನುಗುವುದನ್ನು ಕೇಳಿ ಅದರಂತೆ ನೀವು ಅನುಸರಿಸಿ",
                                "example" : "", 
                            },
                            {
                                "title" : "4 Pattern",
                                "folderName" : "fourpat",
                                "isRandomise" : false,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಗುನುಗುವುದನ್ನು ಕೇಳಿ ಅದರಂತೆ ನೀವು ಅನುಸರಿಸಿ",
                                "example" : "", 
                            }
                        ],
                        "instruction" : "ಗುನುಗುವುದನ್ನು ಕೇಳಿ ಅದರಂತೆ ನೀವು ಅನುಸರಿಸಿ",
                        "example" : ""
                    },
                    {
                        "title" : "6.3 Pattern Completion",
                        "folderName" : "PatternComp",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title" : "Easy",
                                "folderName" : "easy",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಕೇಳಿ ಅದರ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "ಉದಾಹರಣೆ : ಹಿ ಹೊ ಹಿ --- = ಹೊ"
                            },
                            {
                                "title" : "Difficult",
                                "folderName" : "difficult",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಕೇಳಿ ಅದರ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "ಉದಾಹರಣೆ : ಹಿ ಹೊ ಹಿ --- = ಹೊ"
                            },
                            {
                                "title" : "Hard",
                                "folderName" : "Hard",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಕೇಳಿ ಅದರ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "ಉದಾಹರಣೆ : ಹಿ ಹೊ ಹಿ --- = ಹೊ"
                            }
                        ],
                        "instruction" : "ಕೇಳಿ ಅದರ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                        "example" : "ಉದಾಹರಣೆ : ಹಿ ಹೊ ಹಿ --- = ಹೊ"
                    },
                    {
                        "title" : "6.4 Vowels",
                        "folderName" : "Vowels",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title" : "Easy",
                                "folderName" : "easy",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಪದಗಳ ಮಾದರಿಯನ್ನು ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "ಉದಾಹರಣೆ : ಕೋಣ ಕೋಣೆ ಕೋಣ  ಕೋಣೆ ಕೋಣ ... = ಕೋಣೆ"
                            },
                            {
                                "title" : "Difficult",
                                "folderName" : "difficult",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಪದಗಳ ಮಾದರಿಯನ್ನು ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "ಉದಾಹರಣೆ : ಕೋಣ ಕೋಣೆ ಕೋಣ  ಕೋಣೆ ಕೋಣ ... = ಕೋಣೆ"
                            },
                            {
                                "title" : "Hard",
                                "folderName" : "Hard",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಪದಗಳ ಮಾದರಿಯನ್ನು ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "ಉದಾಹರಣೆ : ಕೋಣ ಕೋಣೆ ಕೋಣ  ಕೋಣೆ ಕೋಣ ... = ಕೋಣೆ"
                            }
                        ],
                        "instruction" : "ಪದಗಳ ಮಾದರಿಯನ್ನು ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                        "example" : "ಉದಾಹರಣೆ : ಕೋಣ ಕೋಣೆ ಕೋಣ  ಕೋಣೆ ಕೋಣ ... = ಕೋಣೆ"
                    },
                    {
                        "title" : "6.5 Consonants",
                        "folderName" : "Consonants",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [],
                        "instruction" : "ಪದಗಳ ಮಾದರಿಯನ್ನು ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                        "example" : "ಉದಾಹರಣೆ : ಹಾಡಿ ಮಾಡಿ ಹಾಡಿ ಮಾಡಿ ಹಾಡಿ .... = ಮಾಡಿ"
                    },
                    {
                        "title" : "6.6 Clusters",
                        "folderName" : "Clusters",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title" : "Easy",
                                "folderName" : "easy",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಪದಗಳ ಮಾದರಿಯನ್ನು ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "ಉದಾಹರಣೆ : ಮೈತ್ರಿ ಮೈತ್ರಿ ಮಿತ್ರ .... = ಮಿತ್ರ"                        
                            },
                            {
                                "title" : "Difficult",
                                "folderName" : "difficult",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಪದಗಳ ಮಾದರಿಯನ್ನು ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "ಉದಾಹರಣೆ : ಮೈತ್ರಿ ಮೈತ್ರಿ ಮಿತ್ರ .... = ಮಿತ್ರ"                        
                            },
                            {
                                "title" : "Hard",
                                "folderName" : "Hard",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [],
                                "instruction" : "ಪದಗಳ ಮಾದರಿಯನ್ನು ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                                "example" : "ಉದಾಹರಣೆ : ಮೈತ್ರಿ ಮೈತ್ರಿ ಮಿತ್ರ .... = ಮಿತ್ರ"                        
                            }
                        ],
                        "instruction" : "ಪದಗಳ ಮಾದರಿಯನ್ನು ಕೇಳಿ ಅದರ ಮಾದರಿಯಂತೆ ಅನುಸರಿಸಿ",
                        "example" : "ಉದಾಹರಣೆ : ಮೈತ್ರಿ ಮೈತ್ರಿ ಮಿತ್ರ .... = ಮಿತ್ರ"                        
                    },
                ],
                "instruction" : "",
                "example" : ""
            },
            {
                "title": "7. Auditory Synthesis",    
                "folderName" : "AudSynthesis",    
                "isRandomise" : false,
                "items" : [
                    {
                        "title" : "7.1 Compound Words",
                        "folderName" : "CompWords",    
                        "isRandomise" : true,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [],
                        "instruction" : "ಪದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಒಟ್ಟಿಗೆ ಕೂಡಿಸಿ ಹೇಳಿ",
                        "example" : "ಉದಾಹರಣೆ : ಮನೆ + ಮಠ= ಮನೆ ಮಠ"
                    },
                    {
                        "title" : "7.2 Word",
                        "folderName" : "Words",    
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title": "7.2.1 Familiar",
                                "folderName" : "Familiar",  
                                "isRandomise" : true,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[
                                    {
                                        "title" : "Easy",
                                        "folderName" : "easy",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಅಕ್ಷರಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು  ಅದರಿಂದ ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                        "example" : "ಉದಾಹರಣೆ : ಗ + ಗ + ನ = ಗಗನ"                       
                                    },
                                    {
                                        "title" : "Difficult",
                                        "folderName" : "difficult",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಅಕ್ಷರಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು  ಅದರಿಂದ ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                        "example" : "ಉದಾಹರಣೆ : ಗ + ಗ + ನ = ಗಗನ"                       
                                    },
                                    {
                                        "title" : "Hard",
                                        "folderName" : "Hard",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಅಕ್ಷರಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು  ಅದರಿಂದ ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                        "example" : "ಉದಾಹರಣೆ : ಗ + ಗ + ನ = ಗಗನ"                       
                                    }
                                ],
                                "instruction" : "ಅಕ್ಷರಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು  ಅದರಿಂದ ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ಗ + ಗ + ನ = ಗಗನ"
                            },
                            {
                                "title": "7.2.2 Unfamiliar",
                                "folderName" : "Unfamiliar",  
                                "isRandomise" : false,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[
                                    {
                                        "title" : "Easy",
                                        "folderName" : "easy",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಅಕ್ಷರಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು  ಅದರಿಂದ ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                        "example" : "ಉದಾಹರಣೆ : ಶೃ + o + ಗಾ + ರ =ಶೃoಗಾರ"                     
                                    },
                                    {
                                        "title" : "Difficult",
                                        "folderName" : "difficult",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಅಕ್ಷರಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು  ಅದರಿಂದ ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                        "example" : "ಉದಾಹರಣೆ : ಶೃ + o + ಗಾ + ರ =ಶೃoಗಾರ"                     
                                    },
                                    {
                                        "title" : "Hard",
                                        "folderName" : "Hard",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಅಕ್ಷರಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು  ಅದರಿಂದ ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                        "example" : "ಉದಾಹರಣೆ : ಶೃ + o + ಗಾ + ರ =ಶೃoಗಾರ"                      
                                    },
                                    {
                                        "title" : "Hardest",
                                        "folderName" : "Hardest",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ಅಕ್ಷರಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು  ಅದರಿಂದ ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                        "example" : "ಉದಾಹರಣೆ : ಶೃ + o + ಗಾ + ರ =ಶೃoಗಾರ"                      
                                    }
                                ],
                                "instruction" : "ಅಕ್ಷರಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು  ಅದರಿಂದ ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ಶೃ + o + ಗಾ + ರ =ಶೃoಗಾರ"
                            }
                        ],
                        "instruction" : "ಅಕ್ಷರಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು  ಅದರಿಂದ ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                        "example" : ""
                    },
                    {
                        "title" : "7.3 Phrases",
                        "folderName" : "Phrases",  
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title": "7.3. Familiar",
                                "folderName" : "Familiar",  
                                "isRandomise" : true,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ಪದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅದರಿಂದ ಇನ್ನೊಂದು ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ನೀರು + ಕುಡಿ= ನೀರು ಕುಡಿ"
                            },
                            {
                                "title": "7.3.2 Unfamiliar",
                                "folderName" : "Unfamiliar",
                                "isRandomise" : true,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ಪದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅದರಿಂದ ಇನ್ನೊಂದು ಪದವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ನಮಸ್ತೆ + ಮಾಡು= ನಮಸ್ತೆ ಮಾಡು"
                            }
                        ],
                        "instruction" : "",
                        "example" : ""
                    },
                    {
                        "title" : "7.4 Sentences",
                        "folderName" : "Sentences",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title": "7.4.1 Familiar",
                                "folderName" : "Familiar",
                                "isRandomise" : true,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ಪದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅದರಿಂದ ವಾಕ್ಯವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ನಿನ್ನ + ಹೆಸರು + ಏನು? =ನಿನ್ನ  ಹೆಸರು ಏನು?"                                
                            },
                            {
                                "title": "7.4.2 Unfamiliar",
                                "folderName" : "Unfamiliar",
                                "isRandomise" : true,
                                "subTitle": "",
                                "testCode" : 1,
                                "items":[],
                                "instruction" : "ಪದಗಳನ್ನು ಕೇಳಿಸಿಕೊಂಡು ಅದರಿಂದ ವಾಕ್ಯವನ್ನು ರೂಪಿಸಲು ಒಟ್ಟಿಗೆ ಜೋಡಿಸಿ ಹೇಳಿ",
                                "example" : "ಉದಾಹರಣೆ : ಸೈನಿಕರು+ ದೇಶದ + ಗಡಿ + ಕಾಯುವರು =ಸೈನಿಕರು ದೇಶದ ಗಡಿ ಕಾಯುವರು"
                            }
                        ],
                        "instruction" : "",
                        "example" : ""
                    },
                    {
                        "title" : "7.5 Riddles",
                        "folderName" : "Riddles",
                        "isRandomise" : true,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [],
                        "instruction" : "ಈ ಒಗಟನ್ನು ಬಿಡಿಸಿ ",
                        "example" : "ಉದಾಹರಣೆ : ನಾವು ತಲೆ ಮೇಲೆ ಹಾಕುವ ವಸ್ತು ಹಾಗು  ‘ಟ’ ಅಕ್ಷರದಿಂದ ಶುರುವಾಗುತ್ತೆ = ಟೋಪಿ"
                    },
                ],
                "instruction" : "",
                "example" : ""
            },
            {
                "title": "8. Auditory figure ground",  
                "folderName" : "AudFig",      
                "isRandomise" : false, 
                "items" : [
                    {
                        "title" : "8.1 Following direction",
                        "folderName" : "FollowDir",
                        "isRandomise" : false,
                        "subTitle" : "",
                        "testCode" : 1,
                        "items" : [
                            {
                                "title" : "Simple",
                                "folderName" : "simple",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [
                                    {
                                        "title" : "Easy",
                                        "folderName" : "easy",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                        "example" : ""
                                    },
                                    {
                                        "title" : "Difficult",
                                        "folderName" : "difficult",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                        "example" : ""
                                    },
                                    {
                                        "title" : "Hard",
                                        "folderName" : "Hard",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                        "example" : ""
                                    }
                                ],
                                "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                "example" : ""
                            },
                            {
                                "title" : "Intermediate",
                                "folderName" : "intermediate",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [
                                    {
                                        "title" : "Easy",
                                        "folderName" : "easy",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                        "example" : ""
                                    },
                                    {
                                        "title" : "Difficult",
                                        "folderName" : "difficult",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                        "example" : ""
                                    },
                                    {
                                        "title" : "Hard",
                                        "folderName" : "Hard",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                        "example" : ""
                                    }

                                ],
                                "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                "example" : ""
                            },
                            {
                                "title" : "Complex",
                                "folderName" : "complex",
                                "isRandomise" : true,
                                "testCode" : 1,
                                "items" : [
                                    {
                                        "title" : "Easy",
                                        "folderName" : "easy",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                        "example" : ""
                                    },
                                    {
                                        "title" : "Difficult",
                                        "folderName" : "difficult",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                        "example" : ""
                                    },
                                    {
                                        "title" : "Hard",
                                        "folderName" : "Hard",
                                        "isRandomise" : true,
                                        "testCode" : 1,
                                        "items" : [],
                                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                        "example" : ""
                                    }

                                ],
                                "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                                "example" : ""
                            }
                        ],
                        "instruction" : "ನಾನು ಹೇಳುವುದನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ಅದರಂತೆ ಅನುಸರಿಸಿ ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                        "example" : ""
                    },
                    {
                        "title" : "8.2 Stories",
                        "folderName" : "Stories",
                        "isRandomise" : true,
                        "subTitle" : "",
                        "testCode" : 4.3,
                        "items" : [],
                        "instruction" : "ನಾನು ಹೇಳುವ ಕಥೆಯನ್ನು ಗಮನ ಕೊಟ್ಟು ಕೇಳಿ ನಂತರ ಅದಕ್ಕೆ ಸಂಬಂದಿಸಿದ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಿಸಿ  ಮತ್ತು ಹಿನ್ನೆಲೆ ಶಬ್ದಕ್ಕೆ ಗಮನ ನೀಡದಿರಿ",
                        "example" : ""
                    }
                ],
                "instruction" : "",
                "example" : ""
            },
        ],
        "instruction": "",
        "example" : ""
    }, 
    {
        "title" : "Cognitive", 
        "folderName":"cognitive",
        "isRandomise" : false,
        "items" :[
                {
                    "title" : "Operation Span",
                    "folderName":"opspan",
                    "isRandomise" : true,
                    "testCode" : 5,
                    "items" : [],
                    "instruction" : "ಸಂಖ್ಯೆಯನ್ನು  ಗಮನವಿಟ್ಟು ಕೇಳಿ",
                    "example" : ""
                },
                {
                    "title" : "Reading Span",
                    "folderName":"rdspan",
                    "isRandomise" : true,
                    "testCode" : 6,
                    "items" : [],
                    "instruction" : "ಪದವನ್ನು ಗಮನವಿಟ್ಟು ಕೇಳಿ.",
                    "example" : ""
    
                },           
                {
                    "title" : "Running Span",
                    "folderName":"rnspan",
                    "isRandomise" : true,
                    "testCode" : 7,
                    "items" : [],
                    "instruction" : "ಪದವನ್ನು ಗಮನವಿಟ್ಟು ಕೇಳಿ",
                    "example" : ""
                }
            ],
        "instruction": "",
        "example" : ""

    }
]

export function getModuleList(){    
    return moduleList.map(module=>module.title);
}



export function getObject(moduleName, chapterName, subChapterName, subLevel){  
    if(chapterName===""){    //Get Chapter list
        return moduleList.find(module=>module.title === moduleName)
    }else{
        
        const chapterList =  moduleList.find(module=>module.title === moduleName);   
        if(subChapterName==="") //Get Sub Chapter Names
            return chapterList.items.find(item => item.title === chapterName);

        const subChapterList =  chapterList.items.find(item => item.title === chapterName);             
        if(subLevel==="")
            return  subChapterList.items.find(item => item.title === subChapterName);             
        else
        {
            const subLevelList =  subChapterList.items.find(item => item.title === subChapterName);                
            return  subLevelList.items.find(item => item.title === subLevel);             
        }

        
        // if(subChapterName==="") //Get Sub Chapter Names
        // {
        //     const chapterList =  moduleList.find(module=>module.title === moduleName);             
        //     return chapterList.items.find(item => item.title === chapterName);            
        // }else // get Level list
        // {
        //     if(subLevel==="")
        //     {
        //         const chapterList =  moduleList.find(module=>module.title === moduleName);            
        //         const subChapterList =  chapterList.items.find(item => item.title === chapterName);             
        //         return  subChapterList.items.find(item => item.title === subChapterName);             
        //     }else
        //     {
        //         const chapterList =  moduleList.find(module=>module.title === moduleName);            
        //         const subChapterList =  chapterList.items.find(item => item.title === chapterName);             
        //         const subLevelList =  subChapterList.items.find(item => item.title === subChapterName);                
        //         return  subLevelList.items.find(item => item.title === subLevel);             
        //     }
        // }     
    }
}

















